/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IPresentationMethods,
  PresentationService,
  ISectionMethods,
  SectionService,
  SectionOptionService,
  ISectionOptionMethods,
  FeatureService,
  IFeatureMethods,
  IAttributeMethods,
  AttributeService,
  ValueService,
  IValueMethods,
  IImportCostumeTypeMethods,
  ImportCostumeType,
  GetCostumeValuesService,
  IGetCostumeValuesMethods,
} from "./components";

export type PresentationPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IPresentationMethods &
  ISectionMethods &
  ISectionOptionMethods &
  IFeatureMethods &
  IValueMethods &
  IAttributeMethods &
  IImportCostumeTypeMethods &
  IGetCostumeValuesMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new PresentationService(),
    new SectionService(),
    new SectionOptionService(),
    new FeatureService(),
    new ValueService(),
    new AttributeService(),
    new ImportCostumeType(),
    new GetCostumeValuesService(),
  ];
};

export const getAgent = () => {
  return createAgent<PresentationPageAgent>({
    plugins: getPlugins(),
  });
};
